export default "__VITE_ASSET__D2ma_swx__"